import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GonvarriLoginComponent } from '../../components/gonvarri-login/gonvarri-login.component';
import {CmsConfig, I18nModule, provideConfig, UrlModule} from "@spartacus/core";
import {IconModule, LinkModule, PageSlotModule} from "@spartacus/storefront";
import {RouterLink} from "@angular/router";

@NgModule({
  declarations: [
    GonvarriLoginComponent
  ],
  imports: [
    CommonModule,
    PageSlotModule,
    I18nModule,
    UrlModule,
    RouterLink,
    IconModule,
    LinkModule
  ],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        LoginComponent: {
          component: GonvarriLoginComponent,
        },
      },
    }),
  ],
})
export class GonvarriLoginModule { }
